import { TaxLiability, Payment, ApiResponse, TenantConfig } from '../types';

const API_BASE = '/api';

const TOKEN_KEY = 'tax_auth_token';

export function getStoredToken(): string | null {
  return localStorage.getItem(TOKEN_KEY);
}

export function storeToken(token: string): void {
  localStorage.setItem(TOKEN_KEY, token);
}

export function clearToken(): void {
  localStorage.removeItem(TOKEN_KEY);
}

async function fetchJson<T>(url: string, token?: string | null): Promise<T> {
  const headers: Record<string, string> = {};
  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }
  const response = await fetch(url, { headers });
  if (!response.ok) {
    throw new Error(`API error: ${response.status} ${response.statusText}`);
  }
  return response.json();
}

export async function getPayeLiabilities(token?: string | null): Promise<ApiResponse<TaxLiability[]>> {
  return fetchJson<ApiResponse<TaxLiability[]>>(`${API_BASE}/paye`, token);
}

export async function getVatLiabilities(token?: string | null): Promise<ApiResponse<TaxLiability[]>> {
  return fetchJson<ApiResponse<TaxLiability[]>>(`${API_BASE}/vat`, token);
}

export async function getPayments(token?: string | null): Promise<ApiResponse<Payment[]>> {
  return fetchJson<ApiResponse<Payment[]>>(`${API_BASE}/payments`, token);
}

export async function getTenantConfig(): Promise<TenantConfig | null> {
  try {
    return await fetchJson<TenantConfig>(`${API_BASE}/tenant`);
  } catch {
    return null;
  }
}

export async function verifyPassphrase(passphrase: string): Promise<string> {
  const response = await fetch(`${API_BASE}/auth/verify`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ passphrase }),
  });
  if (!response.ok) {
    throw new Error('Incorrect passphrase');
  }
  const data = await response.json();
  return data.token;
}
